import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseCheckmarkFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.8 1.9a2 2 0 0 1 2.4 0l10.09 9.5a2 2 0 0 1 .71 1.53V28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12.93a2 2 0 0 1 .71-1.53zm8.492 11.54a1 1 0 0 0-1.414-.02l-8.417 8.178-3.466-3.21a1 1 0 0 0-1.36 1.468l4.86 4.499 9.777-9.501a1 1 0 0 0 .02-1.414"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseCheckmarkFilledSVG);
ForwardRef.displayName = "IconHouseCheckmarkFilled";
export { ForwardRef as IconHouseCheckmarkFilled };
